export type OrderLine = {
  projectNo: string;
  deliveryId: number;
  lineNo: number;
  itemNo: string;
  itemDescription: string;
  itemQuantity: number;
  itemUnit: string;
  itemUnitPrice: number;
  orderDescription: string;
  contractStatus: "001" | "002" | "003";
  installtionCompleteDate?: string;
  bizArea?:
    | "BABLK"
    | "BADIV"
    | "BAPGB"
    | "BARHR"
    | "BARST"
    | "BATRP"
    | "BATRT"
    | "BATSP"
    | "BATSV"
    | "HNDV"
    | "PRO"
    | "PRTJ"
    | "SM"
    | "STDV";
  orderClassification?: string;
  productGroup?: string;
  productType?: string;
  sentBusinessCentral: boolean;
  sentTime: string;
  sentByUser: string;
  orderNo: string;
  orderUrl: string;
  orderCreatedTime: string;
  businessCentralStatusCode: string;
  businessCentralStatusMessage: string;
  // The row in excel this line is stored
  originalIndex: number;

  toExcelRow: () => any[];
};

export class OrderLineModel implements OrderLine {
  projectNo!: string;
  deliveryId!: number;
  lineNo!: number;
  itemNo!: string;
  itemDescription!: string;
  itemQuantity!: number;
  itemUnit!: string;
  itemUnitPrice!: number;
  orderDescription!: string;
  contractStatus!: "001" | "002" | "003";
  installtionCompleteDate?: string;
  bizArea?:
    | "BABLK"
    | "BADIV"
    | "BAPGB"
    | "BARHR"
    | "BARST"
    | "BATRP"
    | "BATRT"
    | "BATSP"
    | "BATSV"
    | "HNDV"
    | "PRO"
    | "PRTJ"
    | "SM"
    | "STDV";
  orderClassification?: string;
  productGroup?: string;
  productType?: string;
  sentBusinessCentral!: boolean;
  sentTime!: string;
  sentByUser!: string;
  orderNo!: string;
  orderUrl!: string;
  orderCreatedTime!: string;
  businessCentralStatusCode!: string;
  businessCentralStatusMessage!: string;

  originalIndex!: number;

  constructor(row: any[], index: number) {
    this.toLine(row);
    this.originalIndex = index;
  }

  private toLine(row: any[]) {
    this.projectNo = row[0];
    this.deliveryId = row[1];
    this.lineNo = row[2];
    this.itemNo = `${row[3]}`;
    this.itemDescription = row[4];
    this.itemQuantity = +row[5];
    this.itemUnit = row[6];
    this.itemUnitPrice = +row[7];
    this.orderDescription = row[8];
    this.contractStatus = row[9];
    this.installtionCompleteDate = row[10];
    this.bizArea = row[11];
    this.productGroup = row[12];
    this.productType = row[13];
    this.orderClassification = row[14];
    this.sentBusinessCentral = row[15];
    this.sentTime = row[16];
    this.sentByUser = row[17];
    this.orderNo = row[18];
    this.orderUrl = row[19];
    this.orderCreatedTime = row[20];
    this.businessCentralStatusCode = row[21];
    this.businessCentralStatusMessage = row[22];
  }

  public toExcelRow() {
    // Matches columns in excel sheet
    return [
      this.projectNo,
      this.deliveryId,
      this.lineNo,
      this.itemNo,
      this.itemDescription,
      this.itemQuantity,
      this.itemUnit,
      this.itemUnitPrice,
      this.orderDescription,
      this.contractStatus,
      this.installtionCompleteDate,
      this.bizArea,
      this.productGroup,
      this.productType,
      this.orderClassification,
      this.sentBusinessCentral,
      this.sentTime,
      this.sentByUser,
      this.orderNo,
      this.orderUrl,
      this.orderCreatedTime,
      this.businessCentralStatusCode,
      this.businessCentralStatusMessage,
    ];
  }
}
